/**
 * Gets the cloudId from document
 * cloudId is stored in a meta tag with name "ajs-cloud-id" generated by SSR
 */
export const getCloudIdFromDocument = (): string | null => {
	const metaTag = globalThis.document?.querySelector('meta[name="ajs-cloud-id"]');
	if (metaTag && metaTag.getAttribute('content')) {
		return metaTag.getAttribute('content');
	}

	// Fallback to null if not found
	return null;
};
